import * as React from "react";
const SvgCalendar = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "currentColor", d: "M9 1v2h6V1h2v2h5v18H2V3h5V1zm11 10H4v8h16zM7 5H4v4h16V5h-3v2h-2V5H9v2H7z" })));
export default SvgCalendar;
//# sourceMappingURL=Calendar.js.map